const SERVE = ["Hotels", "Restaurants", "Caterers", "Distributors"];

export default function ServeStrip() {
  return (
    <section className="sect serve" data-testid="serve-strip-section">
      <div className="sect-in serve-in">
        <p className="kicker">Who we serve</p>
      </div>
      <div className="serve-words" data-testid="serve-words" aria-label={SERVE.join(", ")}>
        <div className="serve-track">
          {[0, 1].map((group) => (
            <div className="serve-group" key={group} aria-hidden={group === 1}>
              {SERVE.map((word) => (
                <span className="serve-item" key={`${group}-${word}`}>
                  {word}
                  <span className="serve-dot" aria-hidden="true">•</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
